import { Box, Button, Container, Grid } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { calendarActions } from "../../redux/reducer/calendar/calendarReducer";
import { getMonth } from "../../utils/calendarUtils";
import Day from "./Day";

export const Calendar = () => {
  // Redux
  const dispatch = useDispatch();
  const monthIndex = useSelector((state) => state.calendar.monthIndex);
  const estimateData = useSelector((state) => state.harvestEstimate.dashboard);

  // Local State
  const [currentMonth, setCurrentMonth] = useState(getMonth());
  const [fetch, setFetch] = useState(true);

  const handleNext = () => {
    dispatch(calendarActions.next());
    setFetch(true);
  };

  const handlePrev = () => {
    dispatch(calendarActions.prev());
    setFetch(true);
  };

  useEffect(() => {
    if (fetch) {
      setCurrentMonth(getMonth(monthIndex));
      setFetch(false);
    }
  }, [currentMonth, fetch]);

  return (
    <Container>
      {estimateData.length > 0 && (
        <Grid container>
          <Grid
            item
            xs={12}
            display={"flex"}
            marginY={2}
            justifyContent="center"
            alignItems="center"
          >
            <Button onClick={() => handlePrev()} variant="contained">
              Prev
            </Button>
            <div style={{ margin: "10px 10px " }}>
              {dayjs(new Date(dayjs().year(), monthIndex)).format("MMMM YYYY")}
            </div>
            <Button onClick={() => handleNext()} variant="contained">
              Next
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            {currentMonth.map((row, i) => {
              return (
                <Box display="flex" key={i} width="100%">
                  {row.map((day, idx) => {
                    return (
                      <Box
                        display="flex"
                        flexDirection="column"
                        key={idx}
                        minHeight="110px"
                        width="100%"
                        style={{ border: "1px solid black" }}
                      >
                        <Day day={day} row={i} data={estimateData} />
                      </Box>
                    );
                  })}
                </Box>
              );
            })}
          </Grid>
        </Grid>
      )}
    </Container>
  );
};
